export class AdvisorDashboardStatistics {
  openInvitationsCount: number;
  referralCount: number;
  registeredClientsCount: number;
  onboardingClientsCount: number;
  registeredClientsByDay: number[];
  approvedMandateCount: number;
  approvedMandateCountYesterday: number;
  approvedMandateCountToday: number;
  lastRegisteredClients: LastRegisteredClientsModel[];
}

export class LastRegisteredClientsModel {
  userId: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  registrationDate: string;
}

export class AdvisorAnalysisStatistics {
  openInvitationsCount: number;
  referralCount: number;
  registeredClientsCount: number;
  onboardingClientsCount: number;
  approvedMandateCount: number;
  approvedMandateCountYesterday: number;
  approvedMandateCountToday: number;
  averageAge: number;
  averageAmountChildren: number;
  clientCountByProfessionStatus: ClientCountByProfessionStatus;
  clientCountByRelationshipStatus: ClientCountByRelationshipStatus;
  clientCountByMobilityStatus: ClientCountByMobilityStatus;
  clientCountByHealthInsuranceStatus: ClientCountByHealthInsuranceStatus;
  clientCountByPet: ClientCountByPet;
  clientCountByProvisionTarget: ClientCountByProvisionTarget;
  clientCountByMiscellaneousProperty: ClientCountByMiscellaneousProperty;
  clientCountByHousingSituationStatus: ClientCountByHousingSituationStatus;
  clientCountByPropertyOwnershipStatus: ClientCountByPropertyOwnershipStatus;
}

export class ClientCountByProfessionStatus {
  CIVIL_SERVANT: 4;
  CONTRACTOR: 11;
  EMPLOYED: 258;
  NO_EMPLOYMENT: 4;
  PENSIONER: 30;
  PUBLIC_SERVICE: 16;
  STUDENT: 11;
  TRAINEE: 9;
}

export class ClientCountByMobilityStatus {
  CAR: 234;
  E_BIKE: 41;
  MOTORCYCLE: 231;
  NONE: 25;
}

export class ClientCountByRelationshipStatus {
  DIVORCED: 13;
  MARRIED: 25;
  PARTNER: 28;
  SINGLE: 265;
  WIDOWED: 17;
}

export class ClientCountByHealthInsuranceStatus {
  LEGALLY: 245;
  NONE: 33;
  PRIVATE: 34;
  PRIVATE_BASIC: 26;
}

export class ClientCountByPet {
  CAT: 216;
  DOG: 185;
  HORSE: 47;
  NONE: 34;
  OTHER: 18;
}

export class ClientCountByProvisionTarget {
  BUILDING_UP: 36;
  CHILDREN_FUTURE: 138;
  FINANCIAL_INDEPENDENCY: 103;
  GET_RICH: 70;
  OWN_REAL_ESTATE: 143;
  SECURE_RETIREMENT: 52;
}

export class ClientCountByMiscellaneousProperty {
  BOATS: 37;
  CARAVAN: 16;
  DRONE: 190;
  NONE: 35;
  OIL_TANK: 123;
  PHOTOVOLTAIC: 69;
  TRAILER: 66;
}

export class ClientCountByHousingSituationStatus {
  HOME_OWNER: 55;
  RENT_FREE: 46;
  TENANT: 234;
}

export class ClientCountByPropertyOwnershipStatus {
  CONDO: 64;
  HOUSE: 69;
  NONE: 209;
}

export class FinanceCheckDashboardStatisticModel {
  name: string;
  percentage: number;
  property: string;
  value: number;
  color: string;
}
